import { getFallbackQueryClient as i } from "../../utils/queryClient.js";
async function a(e, t) {
  await (t ?? i()).invalidateQueries({ queryKey: e });
}
export {
  a as refreshQuery
};
